import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Image from "@/components/ui/CardImage";
import { CalendarDays, ChevronLeft, ChevronRight, Sunrise, Sunset } from 'lucide-react';
import { BLUR_PLACEHOLDER, getFocusPointStyle, ImageMetadata } from '@/lib/componentutills';
type DetailItem = {
  label: string;
  value: string;
};
type AuspiciousTime = {
  label: string;
  value: string;
  icon: 'sunrise' | 'sunset';
};
type AstrologycollectionProps = {
  className?: string;
  date?: string;
  dayLabel?: string;
  tamilDateLabel?: string;
  auspiciousTitle?: string;
  auspiciousTimes?: AuspiciousTime[];
  leftColumn?: DetailItem[];
  rightColumn?: DetailItem[];
  imageMetadata?: ImageMetadata;
};
const defaultAuspiciousTimes: AuspiciousTime[] = [{
  label: 'காலை',
  value: '6:30 AM - 7.30 PM',
  icon: 'sunrise'
}, {
  label: 'மாலை',
  value: '4:30 PM - 5.30 PM',
  icon: 'sunset'
}];
const defaultLeftColumn: DetailItem[] = [{
  label: 'ராகு காலம்',
  value: '7:30 AM - 9:00 PM'
}, {
  label: 'எமகண்டம்',
  value: '10:30 AM - 12:00 PM'
}, {
  label: 'குளிகை',
  value: '1:30 PM - 3:00 PM'
}, {
  label: 'யோகம்',
  value: 'அமிர்த யோகம்'
}, {
  label: 'சூலம்',
  value: 'வடக்கு'
}, {
  label: 'பரிகாரம்',
  value: 'பால்'
}];
const defaultRightColumn: DetailItem[] = [{
  label: 'திதி',
  value: 'அஷ்டமி'
}, {
  label: 'நட்சத்திரம்',
  value: 'கார்த்திகை'
}, {
  label: 'சந்திராஷ்டமம்',
  value: 'சுவாதி'
}, {
  label: 'விசேஷம்',
  value: 'ஆனி உத்திர தரிசனம். மதுராந்தகம் கோதண்ட ராமசுவாமி உற்சவாரம்பம். ஆனி உத்திர தரிசனம். மதுராந்தகம் கோதண்ட'
}];
const iconClassName = 'h-5 w-5 text-[#FFDB59] sm:h-6 sm:w-6';
function TimeIcon(t0) {
  const $ = _c(2);
  const {
    icon
  } = t0;
  if (icon === "sunrise") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Sunrise className={iconClassName} strokeWidth={1.8} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Sunset className={iconClassName} strokeWidth={1.8} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default function Astrologycollection(t0) {
  const $ = _c(54);
  const {
    className: t1,
    date: t2,
    dayLabel: t3,
    tamilDateLabel: t4,
    auspiciousTitle: t5,
    auspiciousTimes: t6,
    leftColumn: t7,
    rightColumn: t8,
    imageMetadata
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const date = t2 === undefined ? "26 \u0B9C\u0BC2\u0BA9\u0BCD, 2023" : t2;
  const dayLabel = t3 === undefined ? "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0B9F\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8" : t3;
  const tamilDateLabel = t4 === undefined ? "\u0B9A\u0BCB\u0BAA\u0B95\u0BBF\u0BB0\u0BC1\u0BA4\u0BC1 \u0B86\u0BA3\u0BCD\u0B9F\u0BC1, \u0B86\u0BA9\u0BBF 11-\u0B86\u0BAE\u0BCD \u0BA4\u0BC7\u0BA4\u0BBF" : t4;
  const auspiciousTitle = t5 === undefined ? "\u0B9A\u0BBF\u0BB1\u0BA8\u0BCD\u0BA4 \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD" : t5;
  const auspiciousTimes = t6 === undefined ? defaultAuspiciousTimes : t6;
  const leftColumn = t7 === undefined ? defaultLeftColumn : t7;
  const rightColumn = t8 === undefined ? defaultRightColumn : t8;
  const t9 = `relative overflow-hidden bg-[#163B8D] text-white shadow-lg ${className}`;
  let t10;
  if ($[0] !== imageMetadata) {
    t10 = getFocusPointStyle(imageMetadata);
    $[0] = imageMetadata;
    $[1] = t10;
  } else {
    t10 = $[1];
  }
  let t11;
  if ($[2] !== t10) {
    t11 = <Image src="https://media.dinamani.com/dinamani/2026-02-27/wok2tovm/astrologybg.png" alt="Astrology background" fill={true} className="object-cover" style={t10} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} />;
    $[2] = t10;
    $[3] = t11;
  } else {
    t11 = $[3];
  }
  let t12;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="absolute inset-0 bg-[#163B8D]/88" />;
    $[4] = t12;
  } else {
    t12 = $[4];
  }
  let t13;
  if ($[5] !== t11) {
    t13 = <div className="absolute inset-0 -z-10">{t11}{t12}</div>;
    $[5] = t11;
    $[6] = t13;
  } else {
    t13 = $[6];
  }
  let t14;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <CalendarDays className="h-5 w-5 text-white/90 sm:h-6 sm:w-6" strokeWidth={1.8} />;
    $[7] = t14;
  } else {
    t14 = $[7];
  }
  let t15;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <button type="button" aria-label="Previous date" className="text-white/80 transition-colors hover:text-white"><ChevronLeft className="h-4 w-4 sm:h-5 sm:w-5" strokeWidth={2} /></button>;
    $[8] = t15;
  } else {
    t15 = $[8];
  }
  let t16;
  if ($[9] !== date) {
    t16 = <span className="text-16-tamil-700 text-[#FFDB59] sm:text-18-tamil-700">{date}</span>;
    $[9] = date;
    $[10] = t16;
  } else {
    t16 = $[10];
  }
  let t17;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <button type="button" aria-label="Next date" className="text-white/80 transition-colors hover:text-white"><ChevronRight className="h-4 w-4 sm:h-5 sm:w-5" strokeWidth={2} /></button>;
    $[11] = t17;
  } else {
    t17 = $[11];
  }
  let t18;
  if ($[12] !== t16) {
    t18 = <div className="flex items-center justify-center gap-4">{t14}<div className="flex items-center gap-3">{t15}{t16}{t17}</div></div>;
    $[12] = t16;
    $[13] = t18;
  } else {
    t18 = $[13];
  }
  let t19;
  if ($[14] !== dayLabel) {
    t19 = <p className="text-14-tamil-500 text-white/90">{dayLabel}</p>;
    $[14] = dayLabel;
    $[15] = t19;
  } else {
    t19 = $[15];
  }
  let t20;
  if ($[16] !== t18 || $[17] !== t19) {
    t20 = <div className="flex flex-col gap-3 text-center lg:items-center">{t18}{t19}</div>;
    $[16] = t18;
    $[17] = t19;
    $[18] = t20;
  } else {
    t20 = $[18];
  }
  let t21;
  if ($[19] !== tamilDateLabel) {
    t21 = <p className="text-center text-14-tamil-500 text-white sm:text-16-tamil-500">{tamilDateLabel}</p>;
    $[19] = tamilDateLabel;
    $[20] = t21;
  } else {
    t21 = $[20];
  }
  let t22;
  if ($[21] !== t20 || $[22] !== t21) {
    t22 = <div className="flex flex-col gap-4 px-5 py-5 sm:px-6 lg:justify-center lg:px-10 lg:py-6 lg:border-r lg:border-white/15">{t20}{t21}</div>;
    $[21] = t20;
    $[22] = t21;
    $[23] = t22;
  } else {
    t22 = $[23];
  }
  let t23;
  if ($[24] !== auspiciousTitle) {
    t23 = <p className="mb-4 text-center text-16-tamil-700 text-[#FFDB59] sm:mb-5">{auspiciousTitle}</p>;
    $[24] = auspiciousTitle;
    $[25] = t23;
  } else {
    t23 = $[25];
  }
  let t24;
  if ($[26] !== auspiciousTimes) {
    t24 = auspiciousTimes.map(_temp);
    $[26] = auspiciousTimes;
    $[27] = t24;
  } else {
    t24 = $[27];
  }
  let t25;
  if ($[28] !== t24) {
    t25 = <div className="grid gap-4 sm:grid-cols-2 sm:gap-6">{t24}</div>;
    $[28] = t24;
    $[29] = t25;
  } else {
    t25 = $[29];
  }
  let t26;
  if ($[30] !== t23 || $[31] !== t25) {
    t26 = <div className="px-5 py-5 sm:px-6 lg:px-10 lg:py-6">{t23}{t25}</div>;
    $[30] = t23;
    $[31] = t25;
    $[32] = t26;
  } else {
    t26 = $[32];
  }
  let t27;
  if ($[33] !== t22 || $[34] !== t26) {
    t27 = <div className="grid grid-cols-1 border-b border-white/10 lg:grid-cols-[1fr_1.05fr]">{t22}{t26}</div>;
    $[33] = t22;
    $[34] = t26;
    $[35] = t27;
  } else {
    t27 = $[35];
  }
  let t28;
  if ($[36] !== leftColumn) {
    t28 = leftColumn.map(_temp2);
    $[36] = leftColumn;
    $[37] = t28;
  } else {
    t28 = $[37];
  }
  let t29;
  if ($[38] !== t28) {
    t29 = <div className="space-y-4">{t28}</div>;
    $[38] = t28;
    $[39] = t29;
  } else {
    t29 = $[39];
  }
  let t30;
  if ($[40] !== rightColumn) {
    t30 = rightColumn.map(_temp3);
    $[40] = rightColumn;
    $[41] = t30;
  } else {
    t30 = $[41];
  }
  let t31;
  if ($[42] !== t30) {
    t31 = <div className="space-y-4">{t30}</div>;
    $[42] = t30;
    $[43] = t31;
  } else {
    t31 = $[43];
  }
  let t32;
  if ($[44] !== t29 || $[45] !== t31) {
    t32 = <div className="grid gap-5 px-5 py-6 sm:px-6 lg:grid-cols-2 lg:gap-10 lg:px-10 lg:py-8">{t29}{t31}</div>;
    $[44] = t29;
    $[45] = t31;
    $[46] = t32;
  } else {
    t32 = $[46];
  }
  let t33;
  if ($[47] !== t27 || $[48] !== t32) {
    t33 = <div className="relative z-10">{t27}{t32}</div>;
    $[47] = t27;
    $[48] = t32;
    $[49] = t33;
  } else {
    t33 = $[49];
  }
  let t34;
  if ($[50] !== t13 || $[51] !== t33 || $[52] !== t9) {
    t34 = <section className={t9}>{t13}{t33}</section>;
    $[50] = t13;
    $[51] = t33;
    $[52] = t9;
    $[53] = t34;
  } else {
    t34 = $[53];
  }
  return t34;
}
function _temp3(item_0) {
  return <div key={item_0.label} className="grid grid-cols-[minmax(100px,140px)_1fr] items-start gap-4 sm:grid-cols-[150px_1fr]"><span className="text-16-tamil-700 text-[#FFDB59]">{item_0.label}</span><span className={`text-16-tamil-500 text-white ${item_0.label === "\u0BB5\u0BBF\u0B9A\u0BC7\u0BB7\u0BAE\u0BCD" ? "leading-7" : ""}`}>{item_0.value}</span></div>;
}
function _temp2(item) {
  return <div key={item.label} className="grid grid-cols-[minmax(100px,140px)_1fr] items-start gap-4 sm:grid-cols-[150px_1fr]"><span className="text-16-tamil-700 text-[#FFDB59]">{item.label}</span><span className="text-16-tamil-500 text-white">{item.value}</span></div>;
}
function _temp(time) {
  return <div key={time.label} className="flex items-center gap-3"><TimeIcon icon={time.icon} /><div><p className="text-14-tamil-500 text-white">{time.label}</p><p className="text-14-tamil-700 text-white/90">{time.value}</p></div></div>;
}